import React from "react";

// Webpack 5 + react-flagpack CJS interop
// eslint-disable-next-line @typescript-eslint/no-var-requires
const FlagComponent = require("react-flagpack");

type FlagProps = {
  code?: string;
  size?: "s" | "m" | "l";
  gradient?: string;
  hasBorder?: boolean;
  hasDropShadow?: boolean;
  hasBorderRadius?: boolean;
  className?: string;
};

const Flag: React.FC<FlagProps> = (props) => {
  return React.createElement(FlagComponent, props);
};

export default Flag;
